export default __webpack_public_path__ + "static/media/img_main.12a2271d.png";